/*eslint-env jquery*/
import React, { Component, useState } from 'react'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { brandsService } from '../../_services/brands.service'
import Modal from 'react-responsive-modal'
import PicUploader from '../Shared/PicUploader'
import MeasurementTypeSelect from '../Shared/MeasurementTypeSelect'
import { FaPlus } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { FiTrash2 } from 'react-icons/fi'
import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai"
import config from '../../config'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from "react-table"

import { Input } from 'antd'
import { Tabs, Tab } from 'react-bootstrap'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

export class DataTable extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      initialItems: [],
      data: [],
      modal: false,
      modalHeading: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      activeTab: 'material',
      model: { name: '', image: '' }
    }

    this.getData()
  }

  handleModalCreate = () => {
    this.setState({ modalHeading: 'ثبت برند جدید', modal: true, model: { name: '', image: '' } });
  }

  handleModalEdit = (e) => {
    let _model = this.state.data[e];
    this.setState({ modal: true, model: _model, modalHeading: 'ویرایش برند "' + _model.name + '"' });
  }

  handleModalHide = (e) => {
    var evt = e || window.event; // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault();
    }
    this.setState({ modal: false });
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false });
  }

  getData() {
    brandsService.getAll(this.props.brandType)
      .then((res) => {
        console.log(res.data)
        this.setState({ data: res.data, loading: false, isSubmitting: false, modal: false });
      })
      .catch((error) => {
        this.handleError(error)
      });
  };


  handleError(error) {
    this.setState({ loading: false });
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = (e) => {
    let _model = this.state.data[e];

    this.setState({ confirmDeleteShow: true, model: _model });
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false });

    brandsService.delete(this.state.model.id)
      .then((res) => {
        toastr.success('حذف برند', 'برند با موفقیت حذف شد');
        this.getData();
      })
      .catch((error) => {
        this.handleError(error)
      });
  }

  handleSubmit = (values) => {
    this.setState({ loading: true });
    // console.log(JSON.stringify(values));
    values["brandType"] = this.props.brandType;

    if (values.id) {

      brandsService.edit(values.id, JSON.stringify(values))
        .then((res) => {

          toastr.success('ویرایش برند', 'برند "' + values.name + '" با موفقیت ویرایش شد');
          this.setState({ modal: false });
          this.getData();

        })
        .catch((error) => {
          this.handleError(error)
        });

    } else {
      console.log(JSON.stringify(values));
      brandsService.add(JSON.stringify(values))
        .then((res) => {

          toastr.success('ثبت برند جدید', 'برند "' + res.data.name + '" با موفقیت ثبت شد');
          this.setState({ modal: false });
          this.getData();

        })
        .catch((error) => {
          this.handleError(error)
        });

    }
  }

  render() {

    const ValidationSchema = Yup.object().shape({
      name: Yup.string().trim().required('نام برند'),
      // measurementType: Yup.string().trim().required('واحد اندازه گیری'),
    });
    const { model, loading } = this.state;
    return (
      <div>

        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            data={this.state.data}
            filterable
            loading={loading}
            previousText='صفحه قبل'
            nextText='صفحه بعد'
            loadingText='در حال بارگذاری ...'
            noDataText='نتیجه ای یافت نشد'
            pageText='صفحه'
            ofText='از'
            rowsText='تعداد نمایش'

            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value}
            columns={[
              {
                Header: "ردیف",
                id: "row",
                maxWidth: 50,
                filterable: false,
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                className: "numberFa",
                Cell: (row) => {
                  return row.index + 1;
                }
              },
              {
                Header: 'تصویر',
                accessor: 'image',
                id: "image",
                width: 100,
                sortable: false,
                filterable: false,
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                Cell: row => (
                  <img style={{ width: 80, display: 'inline' }} alt='' src={config.uploadsUrl + 'wwwroot/' + row.original.image} />
                ),
              },
              {
                Header: "نام برند",
                accessor: "name",
                id: "name",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["name"], threshold: matchSorter.rankings.CONTAINS }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              },
              {
                Header: "ویرایش",
                accessor: 'id',
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                sortable: false,
                // filterable: false,
                Filter: ({ filter, onChange }) =>
                  <a onClick={this.handleModalCreate} className="btn btn-primary react-table-add-btn" >
                    <span>
                      <FaPlus size="16px" />
                      افزودن برند جدید
                    </span>
                  </a>,
                Cell: row => (
                  <div>
                    <a onClick={() => this.handleModalEdit(row.index)} data-index={row.index} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn" rel="tooltip" data-original-title="ویرایش"><FiEdit size="24px" /></a>

                    <a onClick={() => this.handleDelete(row.index)} data-index={row.index} className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn" data-original-title="حذف" rel="tooltip"><FiTrash2 size="24px" /></a>
                  </div>
                )
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />

        </div>

        <Dialog
          open={this.state.modal}
          onClose={this.handleModalHide}
          TransitionComponent={Transition}
          scroll={'paper'}
          fullWidth={true}
          maxWidth="sm"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description">
          <DialogTitle>
            <Fab color="secondary" aria-label="refresh" size="small" onClick={() => this.handleModalHide()} className="modal-close-btn">
              <MdClose size="20px" />
            </Fab>
            <span style={{ marginRight: 10 }}></span>
          </DialogTitle>
          <DialogContent dividers={true}
            style={{ overflowY: 'visible', minHeight: 225 }}
          >

            <Formik
              initialValues={model}
              onSubmit={(values, { setSubmitting }) => {
                // // console.log(values);
                this.handleSubmit(values)
              }}
              validationSchema={ValidationSchema}
            >
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                } = props;
                return (

                  <div className="row" style={{ position: "relative" }}>
                    <div className="col-md-12">
                      <form onSubmit={handleSubmit}>

                        <div className="row">
                          <div className="form-inline">

                            <div className="col-md-12 col-sm-12">
                              <label>نام برند</label>
                              <Field type="text"
                                autoFocus
                                name="name"
                                className={
                                  getIn(errors, "name") &&
                                    getIn(touched, "name")
                                    ? "text-input has-error ltr"
                                    : "text-input required ltr"
                                }
                              />
                              <ErrorMessage component={ErrorPopUp} name="name" />
                            </div>

                            {/* <div className="col-md-6 col-sm-6">
                              <label>واحد اندازه گیری</label>
                              <MeasurementTypeSelect
                                defaultValue={values.measurementType}
                                onChange={val => {
                                  setFieldValue("measurementType", val)
                                }}
                                className={
                                  getIn(errors, "measurementType") &&
                                    getIn(touched, "measurementType")
                                    ? "text-input has-error rtl"
                                    : "text-input required rtl"
                                }
                              />
                              <ErrorMessage component={ErrorPopUp} name="measurementType" />
                            </div> */}
                            <div className="clearfix form-row"></div>

                            <div className="col-md-12">
                              <label className="pull-right">تصویر</label>
                              <PicUploader label="تصویر"
                                value={'wwwroot/' + values.image}
                                defaultValue={'wwwroot/' + values.image}
                                onChange={(val) => {
                                  setFieldValue('image', val);
                                }}
                              />
                              <ErrorMessage component={ErrorPopUp} name="image" />
                            </div>
                            <div className="clearfix form-row"></div>

                            <div className="col-md-12">
                              <button type="submit" className={"icon button submit-btn " + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting}>
                                {isSubmitting ?
                                  <AiOutlineLoading className="mdi-spin" size="22px" />
                                  :
                                  <AiOutlineSave size="22px" />
                                }ذخیره</button>
                            </div>
                            <div className="clearfix form-row"></div>

                          </div>
                        </div>


                      </form>
                    </div>
                  </div>

                );
              }}
            </Formik>

          </DialogContent>
        </Dialog >

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={"آیا از حذف برند [" + this.state.model.name + "] مطمئن هستید؟"}
        >
        </MySweetAlert>

      </div >
    );
  }
}


const Brands = props => {
  const [activeTab, setActiveTab] = useState('material')

  return (

    <Tabs transition={false}
      id="controlled-tab-example"
      activeKey={activeTab}
      onSelect={activeTab => setActiveTab(activeTab)}
    >
      <Tab eventKey="material" title="برند های مواد اولیه">
        {activeTab === 'material' ?
          <DataTable brandType={0} />
          : ''}
      </Tab>
      <Tab eventKey="product" title="برند های محصولات">
        {activeTab === 'product' ?
          <DataTable brandType={1} />
          : ''}
      </Tab>
    </Tabs>
  )
}
export default Brands;